export default __webpack_public_path__ + "static/media/thumbnail.8458493e.webp";